'use client';

import { useState, type ReactElement } from 'react';
import { Button, Heading } from '@petsmart-ui/sparky';

import './PaymentForm.scss';
import { RemoveCardModal } from '../RemoveCardModal';
import type { PaymentFormProps } from './types';
import { AddPaymentForm } from './AddPaymentForm';
import { EditPaymentForm } from './EditPaymentForm';

export function PaymentForm({
    title = 'Payments',
    subtitle = 'Add credit or debit card',
    isDefaultCheckDisabled,
    isDefaultCheckChecked,
    editPaymentData,
    closeForm,
    defaultAddressId,
}: PaymentFormProps): ReactElement {
    const [openModal, setOpenModal] = useState<boolean>(false);

    return (
        <div className="payment-form" data-testid="payment-form">
            {title && (
                <Heading tagName="h5" data-testid="payment-form-title">
                    {title}
                </Heading>
            )}

            {subtitle && (
                <Heading
                    tagName="h6"
                    size="body-lg-bold"
                    data-testid="payment-form-subtitle"
                    className={editPaymentData ? 'payment-form__subtitle' : ''}
                >
                    {editPaymentData ? 'Edit card' : subtitle}
                </Heading>
            )}

            {editPaymentData ? (
                <EditPaymentForm
                    isDefaultCheckDisabled={isDefaultCheckDisabled || false}
                    editPaymentData={editPaymentData}
                    closeForm={closeForm}
                />
            ) : (
                <AddPaymentForm
                    isDefaultCheckDisabled={isDefaultCheckDisabled || false}
                    isDefaultCheckChecked={isDefaultCheckChecked || false}
                    closeForm={closeForm}
                    defaultAddressId={defaultAddressId}
                />
            )}

            {editPaymentData && (
                <>
                    <div className="payment-form__remove-button" data-testid="payment-form-remove-button">
                        <Button text="Remove card" variant="link" onClick={() => setOpenModal(true)} />
                    </div>
                    <RemoveCardModal
                        currentPayment={editPaymentData}
                        modalOpen={openModal}
                        modalClose={(hideForm?: boolean) => {
                            setOpenModal(false);
                            if (hideForm) {
                                closeForm();
                            }
                        }}
                    />
                </>
            )}
        </div>
    );
}
